const Divider = () => (
  // bg-neutral-low-300
  <hr className="mb-2 h-px w-full bg-neutral-low-200 content-empty dark:bg-neutral-high-100" />
);

export default Divider;
